import { h } from 'preact'
import ButtonControl from '../../preact-components/button-control'

type ButtonsPosition = 'Right' | 'Left';

interface Props {
  cancelCallback: () => void,
  saveCallback: () => void,
  isLoading: boolean,
  buttonsPosition?: ButtonsPosition
}

const DynamicSaveBar = ({ cancelCallback, saveCallback, isLoading, buttonsPosition } : Props) => (
  <div className={`dynamic-save-bar ${buttonsPosition === 'Right' ? 'dynamic-save-bar--buttons-right' : ''}`}>
    <ButtonControl
      onClick={() => saveCallback()}
      title='Save Changes'
      isLoading={isLoading}
      variant='success'
      class='dynamic-save-bar__save-btn'
    />
    <ButtonControl
      class='dynamic-save-bar__cancel-btn js-cancel'
      onClick={() => cancelCallback()}
      title='Cancel'
      variant='secondary'
    />
  </div>
)

export default DynamicSaveBar
